import React, { Component, useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { Route, Routes, useLocation } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import Layout from './components/Layout';
import messages from './components/messages';
import './custom.css';
import './styles/App.scss';
import authService from './components/api-authorization/AuthorizeService';

function App() {
    const [locale, setLocale] = useState('es');
    const [role, setRole] = useState('');
    const location = useLocation();
    const isStandaloneChat = location.pathname.toLowerCase() === '/asistenteorsero/ventana';

    useEffect(() => {

    },[]);

    const routes = (
        <Routes>
            {AppRoutes.map((route, index) => {
                const { element, requireAuth, requiredRole, ...rest } = route;
                return <Route
                    key={index}
                    {...rest}
                    element={requireAuth
                        ? <AuthorizeRoute {...rest} requiredRole={requiredRole} element={element} />
                        : element}
                />;
            })}
        </Routes>
    );

    return (
        <IntlProvider locale={locale} messages={messages[locale]}>
            {isStandaloneChat ? routes : <Layout>{routes}</Layout>}
        </IntlProvider>
    );

}
export default App;
